import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Popconfirm,
  Tooltip,
  Table,
  Input,
  Modal,
  Card,
  Form,
  Divider,
  DatePicker,
  InputNumber,
  Typography,
  notification,
  message,
  Spin,
  Checkbox,
  Dropdown,
  Menu,
} from "antd";
import * as XLSX from 'xlsx';
import {
  CloseCircleFilled,
  DeleteFilled,
  EditOutlined,
  ExportOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  SyncOutlined,
  MedicineBoxOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import { BpiService } from "../Services/BpiService";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import { DocumentService } from "../Services/DocumentService";
import TableDOc from "./TableDoc";
import { AdherentsService } from "../Services/AdherentsService";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { PrestationsService } from "../Services/PrestationsService";
import { SpecialitesService } from "../Services/SpecialitesService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { ListFournisService } from "../Services/ListFournisService";
import { SuspensionsService } from "../Services/SuspensionsService";
import moment from "moment";

const { Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const LgHospi = () => {
  const bpiService = new BpiService();
  const documentService = new DocumentService();
  const exerciceDocService = new ExerciceDocService();
  const adherentsService = new AdherentsService();
  const participantsIpmService = new ParticipantsIpmService();
  const prestationsService = new PrestationsService();
  const specialistesService = new SpecialitesService();
  const typesBenefsService = new TypesBenefsService();
  const fournisseurService = new ListFournisService();
  const suspensionsService = new SuspensionsService();
  const userProfil = localStorage.getItem("profil");
  const chargesIPMSet = useRef(new Set());
  const endettementSet = useRef(new Set());

  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };

  const [addedRows, setAddedRows] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("KO");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [participantsData, setParticipantsData] = useState(null);
  const [partsData, setPartsData] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [columnFilteredData, setColumnFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [qteTotal, setqteTotal] = useState(0);
  const [prestationsData, setPrestationsData] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);
  const [benefsData, setBenefsData] = useState(null);
  const [actesData, setActesData] = useState([]);
  const [displayRows, setDisplayRows] = useState([]);
  const [isSaisirMedicamentClicked, setIsSaisirMedicamentClicked] =
    useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [specialitesData, setSpecialitesData] = useState(null);
  const [numdoc, setNumdoc] = useState(null);
  const [prescripteursData, setPrescripteursData] = useState([]);
  const [prescripteurData, setPrescripteurData] = useState([]);
  const [isMatriculeSelected, setIsMatriculeSelected] = useState(false);
  const [allBeneficiaires, setAllBeneficiaires] = useState([]);
  const [isBeneficiaireSelected, setIsBeneficiaireSelected] = useState(false);
  const [beneficiaires, setBeneficiaires] = useState([]);
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [addedMedicaments, setAddedMedicaments] = useState([]);
  const [isPrescripteurSelectEnabled, setIsPrescripteurSelectEnabled] =
    useState(false);
  const [adherents, setAdherents] = useState([]);
  const [years, setYears] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isParticipantInactive, setIsParticipantInactive] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [isBonManuel, setIsBonManuel] = useState(false); // État pour la case à cocher "Bon Manuel"

  const userId = localStorage.getItem('login');
  const userRoleName = localStorage.getItem("role_name");

  // Fonction pour gérer le changement de la case à cocher
  const handleBonManuelChange = (e) => {
    setIsBonManuel(e.target.checked);
  };

  const selectedTypeDoc = "LHI"

  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getAllExercicesDoc();
        setYears([...yearsData].sort((a, b) => b - a));
        //await fetchDataByOption(selectedOption);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedOption]);

  useEffect(() => {
    fetchDataByOption(selectedOption);
  }, [selectedYear, selectedTypeDoc, selectedOption]);

  const handleDeleteline = async (numdoc) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteDoc(numdoc);
            const updatedData = filteredData.filter(
              (item) => item.numdoc !== numdoc
            );
            setFilteredData(updatedData);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };

  const handleDeleteSelectedDocuments = () => {
    if (selectedDocuments.length === 0) {
      notification.warning({
        message: "Aucune sélection",
        description: "Veuillez sélectionner au moins un document à supprimer",
      });
      return;
    }

    confirm({
      title: `Êtes-vous sûr de vouloir supprimer ${selectedDocuments.length} document(s) ?`,
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          await documentService.deleteListDocument(selectedDocuments);
          const deletedNumdocs = selectedDocuments.map((doc) => doc.numdoc);
          const updatedData = filteredData.filter(
            (item) => !deletedNumdocs.includes(item.numdoc)
          );
          setFilteredData(updatedData);
          setSelectedDocuments([]);
          notification.success({
            message: "Succès",
            description: "Document(s) supprimé(s) avec succès",
          });
        } catch (error) {
          notification.error({
            message: "Erreur",
            description: "Erreur lors de la suppression des documents sélectionnés",
          });
        }
      },
    });
  };

  const fetchDataByOption = async (option) => {
    setLoading(true);
    try {
      const data = await bpiService.getAllBci(selectedTypeDoc, option, selectedYear);
      if (userRoleName === "Point_Focal") {
        data = data.filter(item => item.user_id === userId);
      }

      setTableData(data);
      setLoading(false);
      //  setShowAdditionalColumns(shouldShowAdditionalColumns);
    } catch (error) {
      setLoading(false);
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData, refreshTable]);

  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };
  const handleRefresh = async () => {
    setRefreshTable(true); // Commencez à afficher l'indicateur de chargement
    try {
      await fetchDataByOption(selectedOption);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setRefreshTable(false); // Masquez l'indicateur de chargement une fois les données récupérées
    }
  };

  //Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  /* const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();
      setAdherents(adherentsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  }; */
  const fetchAdherents = async () => {
    try {
      const isPointFocal =
        userRoleName === "Point_Focal" || userRoleName === "Point Focal";

      const adherentsData = isPointFocal
        ? await adherentsService.getAllAdherentsForPointFocal(userId)
        : await adherentsService.getAllAdherents();

      // Filtrer les adhérents pour exclure ceux qui ont suspension_adht à true
      const filteredAdherents = adherentsData.filter(
        (adherent) => !adherent.suspension_adht
      );
      setAdherents(filteredAdherents);

    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };
  const handleSocieteChange = async (value) => {
    try {
      const participantsData =
        await participantsIpmService.getOneListtParticipant(value);
      setParticipantsData(participantsData);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du participant :",
        error
      );
      // Gérer l'erreur ici si nécessaire
    }
  };
  /*   const handleMatPartChange = async (value) => {
      try {
        const participantData = await participantsIpmService.getOneParticipant(value);
        if (participantData.suspension_part === "S") {
          setSelectedParticipant(participantData);
          setIsParticipantInactive(true);
          return;
        }
    
        const benefData = await participantsIpmService.getBenefParticipant(value);
        setAllBeneficiaires(benefData);
        setBeneficiaires(benefData);
        setPartsData(participantData);
        setIsMatriculeSelected(true);
        setIsBeneficiaireSelected(false);
        form.setFieldsValue({
          codetype: undefined,
          matribenef: undefined,
        });
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: "Erreur lors de la récupération des données du participant",
        });
      }
    }; */

  const handleMatPartChange = async (value) => {
    try {
      const participantData = await participantsIpmService.getOneParticipant(value);

      if (participantData.suspension_part === "S") {
        setSelectedParticipant(participantData);
        setIsParticipantInactive(true);
        return;
      }

      if (participantData.suspension_adht) {
        Modal.confirm({
          title: "Société suspendue!",
          content: "Voulez-vous confirmer cette opération malgré la suspension?",
          okText: "Valider",
          cancelText: "Annuler",
          onOk: async () => {
            proceedWithMatPartChange(value, participantData);
          },
          onCancel: () => {
            form.resetFields(["matripart"]);
          },
        });
        return;
      }

      if (chargesIPMSet.current.has(value)) {
        if (userProfil === "role_1" || userProfil === "role_2") {
          Modal.confirm({
            title: "Dépassement de charges IPM !",
            content: "Ce participant a dépassé son seuil de charges IPM. Voulez-vous continuer la saisie ?",
            okText: "Continuer",
            cancelText: "Annuler",
            okButtonProps: { danger: true },
            onOk: () => proceedWithMatPartChange(value, participantData),
            onCancel: () => form.resetFields(["matripart"]),
          });
        } else {
          Modal.warning({
            title: "Dépassement de charges IPM !",
            content: "Ce participant a dépassé son seuil de charges IPM. Veuillez vous référer au gérant.",
            okText: "Fermer",
            onOk: () => form.resetFields(["matripart"]),
          });
        }
        return;
      }

      if (endettementSet.current.has(value)) {
        if (userProfil === "role_1" || userProfil === "role_2") {
          Modal.confirm({
            title: "Dépassement d'endettement !",
            content: "Ce participant a dépassé son seuil d'endettement. Voulez-vous continuer la saisie ?",
            okText: "Continuer",
            cancelText: "Annuler",
            okButtonProps: { danger: true },
            onOk: () => proceedWithMatPartChange(value, participantData),
            onCancel: () => form.resetFields(["matripart"]),
          });
        } else {
          Modal.warning({
            title: "Dépassement d'endettement !",
            content: "Ce participant a dépassé son seuil d'endettement. Veuillez vous référer au gérant.",
            okText: "Fermer",
            onOk: () => form.resetFields(["matripart"]),
          });
        }
        return;
      }

      proceedWithMatPartChange(value, participantData);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données du participant",
      });
    }
  };

  // Fonction pour continuer après validation
  const proceedWithMatPartChange = async (value, participantData) => {
    try {
      const benefData = await participantsIpmService.getBenefParticipant(value);
      setAllBeneficiaires(benefData);
      setBeneficiaires(benefData);
      setPartsData(participantData);
      setIsMatriculeSelected(true);
      setIsBeneficiaireSelected(false);
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des bénéficiaires",
      });
    }
  };


  const handleTypeBenefChange = async (value) => {
    try {
      // Récupérer les bénéficiaires filtrés en fonction du codetype sélectionné
      const filteredBeneficiaires = allBeneficiaires.filter(
        (beneficiaire) => beneficiaire.codebenef === value
      );
      if (filteredBeneficiaires.length === 0) {
        // Si aucun bénéficiaire n'est trouvé, désactiver le champ du bénéficiaire
        form.setFieldsValue({
          matribenef: undefined,
        });
        setIsBeneficiaireSelected(false);
      } else {
        // S'il y a des bénéficiaires, les mettre à jour dans l'état et activer le champ du bénéficiaire
        setBeneficiaires(filteredBeneficiaires);
        setIsBeneficiaireSelected(true);
        // Sélectionner le premier bénéficiaire de la liste
        form.setFieldsValue({
          matribenef: filteredBeneficiaires[0].matribenef,
        });
      }
    } catch (error) {
      console.error("Erreur lors du filtrage des bénéficiaires :", error);
      // Gérer l'erreur si nécessaire
    }
  };

  const fetchTypeBenef = async () => {
    try {
      const typeBenefData = await typesBenefsService.getAllTypesBenefs();
      setBenefsData(typeBenefData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };
  const fetchSpecialite = async () => {

    try {
      const specialites = await specialistesService.getAllSpecialites();
      // Exclure les codespe:04 et codespe:06
      const filteredSpecialites = specialites.filter(
        (specialite) => specialite.codespe !== "04" && specialite.codespe !== "06"
      );
      setSpecialitesData(filteredSpecialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités :", error);
    }
  };


  const handleFournisseurChangeGeneric = async (value, isPrescripteur = false) => {
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      const filteredFournisseurs = allFournisseurs.filter(
        (fournisseur) => fournisseur.codespe === value
      );

      if (isPrescripteur) {
        setPrescripteursData(filteredFournisseurs);
        setIsPrescripteurSelectEnabled(!!value);
      } else {
        setPrescripteurData(filteredFournisseurs);
        setIsSaisirMedicamentClicked(!!value);

        if (value) {
          const actesResponse = await specialistesService.AddActe(value);
          setActesData(actesResponse);
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des fournisseurs :", error);
    }
  };

  const handleFournisseurChange = (value) => {
    handleFournisseurChangeGeneric(value, false);
  };

  const handleFournisPrescChange = (value) => {
    handleFournisseurChangeGeneric(value, true);
  };

  const fetchPrestation = async () => {
    try {
      const prestations = await prestationsService.getAllPrestation();
      setPrestationsData(prestations);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };
  const loadChargesIPM = async () => {
    try {
      const data = await suspensionsService.getChargesIPM(selectedYear);
      chargesIPMSet.current = new Set(data.map(r => r.numcont).filter(Boolean));
    } catch {
      chargesIPMSet.current = new Set();
    }
  };

  const loadEndettement = async () => {
    try {
      const data = await suspensionsService.getSuspensionsEndettement(selectedYear);
      endettementSet.current = new Set(data.map(r => r.numcont).filter(Boolean));
    } catch {
      endettementSet.current = new Set();
    }
  };

  const handleOpenModal = async (isManual = false) => {
    setIsBonManuel(isManual);
    setLoadingModal(true);
    setIsModalVisible(true);

    try {
      await Promise.all([fetchPrestation(), fetchSpecialite(), fetchTypeBenef(), fetchAdherents(), loadChargesIPM(), loadEndettement()]);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setLoadingModal(false);  // Masquez l'indicateur de chargement une fois les données récupérées
    }
  };


  const handleCloseModal = () => {
    form.resetFields(); // Réinitialiser les champs du formulaire
    setIsModalVisible(false); // Ferme le modal
    setIsEdit(false);
    setIsSaisirMedicamentClicked(false)
    setAddedRows([]); // Réinitialiser les lignes ajoutées
    setAddedMedicaments([]); // Réinitialiser les médicaments ajoutés
    setDisplayRows([]); // Réinitialiser les lignes à afficher
    setIsTableVisible(false);
    setParticipantsData(null)
    setIsBeneficiaireSelected(false)
    setIsMatriculeSelected(false)
    setIsBonManuel(false)
  };
  const handleCloseModalValid = () => {
    form.resetFields(); // Réinitialiser les champs du formulaire
    setIsEdit(false);
    setIsSaisirMedicamentClicked(false)
    setAddedRows([]); // Réinitialiser les lignes ajoutées
    setAddedMedicaments([]); // Réinitialiser les médicaments ajoutés
    setDisplayRows([]); // Réinitialiser les lignes à afficher
    setIsTableVisible(false);
    setParticipantsData(null)
    setIsBeneficiaireSelected(false)
    setIsMatriculeSelected(false)

  };



  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log("Form values:", values);

        const participantDetails = partsData || { categprof: 'N/A' };
        const docData = {
          actes: [...addedRows],
          ...values,
          categprof: participantDetails.categprof,
          montdoc: values.montdoc,
          numdoc: isBonManuel ? values.numdoc : null,
          // datedoc: isBonManuel ? values.datedoc?.format("YYYY-MM-DD") : null,
          datedoc: isBonManuel
            ? values.datedoc?.format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          typedoc: "LHI",
          user_id: userId,
        };

        try {
          const response = await bpiService.AddDoc(docData);

          if (response.Added === false) {
            notification.error({
              message: "Erreur",
              description: "Numéro de bon déjà ajouté.",
            });
          } else {
            handleCloseModalValid();
            fetchDataByOption(selectedOption);
            notification.success({
              message: "Succès",
              description: "Le document a été ajouté avec succès.",
            });
          }
        } catch (error) {
          console.error("Erreur lors de l'ajout du document :", error);
          notification.error({
            message: "Erreur",
            description: "Erreur lors de l'ajout du document: " + error.message,
          });
        }
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };


  const handleAddRow = () => {
    const values = form.getFieldsValue();
    const { codeacte, qte, tarif } = values;

    const selectedActe = actesData.find((acte) => acte.codeacte === codeacte);
    if (!selectedActe) {
      message.error("Acte sélectionné non trouvé.");
      return;
    }

    // Vérifier si le médicament a déjà été ajouté
    if (addedMedicaments.includes(codeacte)) {
      notification.warning({
        message: "Duplication",
        description: "Ce médicament a déjà été ajouté à la table.",
      });
      return;
    }

    const valeurTarif = qte * tarif;

    setqteTotal((prevqteTotal) => prevqteTotal + qte);

    const completeActe = {
      Prestation: selectedActe,
      ajustmt: 0,
      codeprest: "",
      fexclus: 0,
      freel: 0,
      numligne: null,
      qpassur: 0,
      qpmut: 0,
      qte: qte,
      tarif: valeurTarif,
      ticket: 0,
      intitule: "",
      numdoc: "",
    };

    const newRow = {
      key: displayRows.length, // ou un autre identifiant unique
      numero: displayRows.length + 1,
      libacte: selectedActe.libacte,
      qte: qte,
      tarif: valeurTarif,
    };

    setAddedRows((prevAddedRows) => [...prevAddedRows, completeActe]);
    setDisplayRows((prevDisplayRows) => [...prevDisplayRows, newRow]);
    setAddedMedicaments((prevAddedMedicaments) => [
      ...prevAddedMedicaments,
      codeacte,
    ]);
    setIsTableVisible(true);

    // Réinitialisez les champs du formulaire si nécessaire
    form.resetFields(["codeacte", "qte", "tarif"]);
  };



  const handleDelete = (record) => {
    const updatedRows = addedRows.filter((row, index) => index !== record.key);
    const updatedDisplayRows = displayRows.filter((row, index) => index !== record.key);

    // Trouver le codeacte du médicament à supprimer
    const removedActe = addedRows[record.key];
    const updatedMedicaments = addedMedicaments.filter(
      (medicament) => medicament !== removedActe.Prestation.codeacte
    );

    setAddedRows(updatedRows);
    setDisplayRows(updatedDisplayRows);
    setAddedMedicaments(updatedMedicaments);

    if (updatedRows.length === 0) {
      setIsTableVisible(false);
    }
  };



  const handleClearTable = () => {

    setAddedRows([]);
    setAddedMedicaments([]);
  };
  const categoryMapping = {
    1: "1ère Catégorie",
    2: "2ème Catégorie",
    3: "3ème Catégorie",
    4: "4ème Catégorie",
  };



  const handleEdit = async (record) => {
    setIsEdit(true);
    setLoadingModal(true);
    setIsModalVisible(true);

    try {
      const [
        details,
        adherentsData,
        participantsData,
        benefData,
        benefsData,
        specialitesData,
        prescripteurData,
        prescripteursData,
        prestationsData,
      ] = await Promise.all([
        bpiService.GetDetailBpi(record.numdoc),
        adherentsService.getAllAdherents(),
        participantsIpmService.getOneEtParticipant(record.codesoc),
        participantsIpmService.getBenefParticipant(record.matripart),
        typesBenefsService.getAllTypesBenefs(),
        specialistesService.getAllSpecialites(),
        fournisseurService.getAllListFournis(),
        fournisseurService.getAllListFournis(),
        prestationsService.getAllPrestation(),
      ]);

      const selectedBenef = benefsData.find((benef) => benef.codetype === details.typebenef);
      const prescripteurs = prescripteursData.find((prescripteur) => prescripteur.numFourn === details.codepresc);
      const actesData = await specialistesService.AddActe(details.codeprest);

      const extractedCodespe = details.codepresc.substring(0, 2);
      const selectedSpecialite = specialitesData.find((specialite) => specialite.codespe === extractedCodespe);

      const selectedRowData = {
        ...details,
        datepresc: details.datepresc ? moment(details.datepresc) : undefined,
        datedoc: details.datedoc ? moment(details.datedoc) : undefined,
        libtype: selectedBenef ? selectedBenef.libtype : undefined,
        codespe: selectedSpecialite ? selectedSpecialite.codespe : undefined,
        codepresc: prescripteurs ? prescripteurs.numFourn : undefined,
        natprest: details.natprest,
        montant_remise: details.montant_remise,
        montdoc: details.montdoc,
        codeprest: details.codeprest,
        categ: categoryMapping[details.categ], // Convertir la valeur numérique en texte
      };

      setNumdoc(details.numdoc);
      form.setFieldsValue(selectedRowData);

      const actes = details.actes.map((acte, index) => ({
        numero: index + 1,
        libacte: acte.Prestation.libacte,
        qte: acte.qte,
        prix_unitaire: acte.Prestation.tarif,
      }));

      setAddedRows(actes);
      setIsTableVisible(true);
      setAddedRows(actes);
      setIsTableVisible(actes.length > 0);

      setAdherents(adherentsData);
      setParticipantsData(participantsData);
      setBeneficiaires(benefData);
      setBenefsData(benefsData);
      setSpecialitesData(specialitesData);
      setPrescripteurData(prescripteurData);
      setPrescripteursData(prescripteursData);
      setPrestationsData(prestationsData);
      setActesData(actesData);
    } catch (error) {
      console.error("Erreur lors de la récupération des détails :", error);
      if (error.response) {
        console.error("Erreur de l'API:", error.response.data);
      } else {
        console.error("Erreur de l'application:", error.message);
      }
    } finally {
      setLoadingModal(false);  // Masquez l'indicateur de chargement
    }
  };



  const handleModif = () => {
    form
      .validateFields()
      .then(async (values) => {
        const participantDetails = partsData || { categprof: 'N/A' };
        const actes = addedRows.map((row) => ({
          Prestation: {
            codeacte: row.libacte, // Ensure libacte contains the codeacte value
            libacte: row.libacte,
            qte: row.qte,
            coef: 1,
            codespe: values.codespe,
            codeprest: values.codefourn,
          },
          ajustmt: 0,
          codeprest: values.codefourn,
          fexclus: 0,
          freel: 0,
          intitule: "",
          numdoc: "",
          numligne: null,
          qpassur: 0,
          qpmut: 0,
          qte: row.qte,
          tarif: row.prix_unitaire,
          ticket: 0,
        }));
        const docData = {
          actes,
          categprof: participantDetails.categprof,
          natprest: values.natprest,
          codefourn: values.codefourn,

          codesoc: values.codesoc,
          codepresc: values.codepresc,
          datepresc: values.datepresc
            ? values.datepresc.format("YYYY-MM-DD")
            : "",
          datedoc: form.getFieldValue("datedoc")?.format("YYYY-MM-DD") || null,
          codeprest: values.prestataireSpe,
          matribenef: values.matribenef,
          matripart: values.matripart,
          montant_remise: values.montant_remise,
          nbarticle: values.nbarticle,
          montdoc: values.montdoc,
          numdoc: numdoc,
          remb_integral: values.remb_integral,
          typebenef: values.typebenef,
          typedoc: "LHI",
          user_id: userId,
        };

        try {
          await bpiService.UpdateDetailBpi(docData);

          handleCloseModal();
          fetchDataByOption(selectedOption);
          notification.success({
            message: "Succès",
            description: "Le document a été modifié avec succès.",
          });
        } catch (error) {
          console.error("Erreur lors de l'ajout du document :", error);
        }
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };
  const handleExportClick = () => {
    if (!Array.isArray(columnFilteredData) || columnFilteredData.length === 0) {
      notification.warning({
        message: "Aucune donnée",
        description: "Il n'y a aucune donnée à exporter",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(columnFilteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportData");

    XLSX.writeFile(workbook, "export.xlsx");
  };

  const formatNumberWithSeparator = (number) => {
    return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
  };

  return (
    <div>
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "40px" }}
        >
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              }}
            >
              <MedicineBoxOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Lettres Hospitalisation
              </span>
            </div>
          </Col>

          <Col>
            <Select
              className="select-colored-accent"
              style={{
                width: 100,
                marginRight: 10,
                "--select-accent": "#1890ff",
                "--select-accent-bg": "#e6f4ff",
                "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
              }}
              onChange={handleYearChange}
              value={selectedYear}
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>

            <Select
              className="select-colored-accent"
              style={{
                width: 200,
                marginRight: 10,
                "--select-accent": "#722ed1",
                "--select-accent-bg": "#f9f0ff",
                "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
              }}
              onChange={handleSelectChange}
              value={selectedOption}
            >
              <Option value="AA">Tous les Documents</Option>
              <Option value="OK">Traité</Option>
              <Option value="KO">Non Traité</Option>
            </Select>
            <Input
              className="search-input-highlight"
              placeholder="Rechercher..."
              allowClear
              prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              style={{
                width: 200,
                marginRight: 10,
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              className="buttonRecep"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(false)}
              icon={<PlusCircleOutlined />}
            >
              Lettre de prise en charge
            </Button>
            <Button
              className="ButtonbonManuel"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(true)}
              icon={<PlusCircleOutlined />}
            >
              Lettre Facturée
            </Button>
            <Button icon={<ExportOutlined />} className="buttonExport" style={{ marginRight: 10 }} onClick={handleExportClick}>
              Export
            </Button>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="refresh"
                    icon={refreshTable ? <Spin size="small" /> : <SyncOutlined />}
                    disabled={refreshTable}
                    onClick={handleRefresh}
                  >
                    Actualiser
                  </Menu.Item>
                  <Menu.Item
                    key="deleteSelected"
                    icon={<DeleteFilled />}
                    danger
                    disabled={selectedDocuments.length === 0}
                    onClick={handleDeleteSelectedDocuments}
                  >
                    Supprimer la sélection {selectedDocuments.length > 0 ? `(${selectedDocuments.length})` : ""}
                  </Menu.Item>
                </Menu>
              }
              placement="bottomRight"
            >
              <Button className="buttonRefresh" icon={<SyncOutlined spin={refreshTable} />}>
                <DownOutlined />
              </Button>
            </Dropdown>

          </Col>
        </Row>
        <TableDOc
          size="small"
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table"
          bordered
          loading={loading}
          isPharmacieComponent={false}
          dataSource={filteredData}
          showSorterTooltip={false}
          showAdditionalColumns={selectedOption === "OK"}
          handleDeleteline={handleDeleteline}
          onEdit={handleEdit}
          onSelectionChange={(keys, rows) => setSelectedDocuments(rows)}
          onFilteredDataChange={setColumnFilteredData}
        />
        <Modal
          open={isModalVisible}
          style={{
            top: 20,
          }}
          maskClosable={false}
          footer={null}
          onCancel={handleCloseModal}
          width={1000}
          className="modal-header"
          title={
            <div>
              {isEdit
                ? "Modifier Lettre d'hospotalisation"
                : "Création Lettre d'hospotalisation"}
              {isEdit && (
                <div style={{ fontSize: "14px", marginTop: "2px" }}>
                  Numéro : {numdoc}
                </div>
              )}
            </div>
          }
        >
          {loadingModal ? (
            <Spin tip="Chargement..." style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
          ) : (
            <Form form={form} layout="vertical">
              {isBonManuel && (
                <Row gutter={16}>
                  <Divider orientation="left">
                    Infos Bon
                  </Divider>

                  <>
                    <Col span={8}>
                      <Form.Item
                        name="numdoc"
                        label="Numéro Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez entrer le numéro du bon",
                          },
                          {
                            pattern: /^[^/@#$]*$/,
                            message: "Le numéro du bon ne peut pas contenir les caractères suivants: / @ # $",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="datedoc"
                        label="Date Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner la date du bon",
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          }
                          style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="montdoc"
                        label="Montant Bon"
                        initialValue={0}
                      >
                        <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>

                </Row>
              )}
              <Row gutter={20}>
                <Col span={12}>
                  <Divider orientation="left">
                    <strong> Participant</strong>
                  </Divider>
                  <Form.Item
                    name="codesoc"
                    label="Société"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une société",
                      },
                    ]}

                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue={"--Selectionner--"}
                      onChange={handleSocieteChange}
                      disabled={isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {adherents.map((adherent) => (
                        <Option key={adherent.codeadht} value={adherent.codeadht}>
                          {`${adherent.codeadht} - ${adherent.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matripart"
                    label="Matricule participant"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      defaultValue={"--Selectionner--"}
                      style={{ width: "100%" }}
                      disabled={!participantsData || isEdit} // Grise si participantsData est null
                      onChange={handleMatPartChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {participantsData &&
                        participantsData.map((participant) => (
                          <Option
                            key={participant.numcont}
                            value={participant.numcont}
                          >
                            {`${participant.matricule} - ${isEdit
                              ? participant.prenom + " " + participant.nom
                              : participant.part
                              }`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Divider orientation="left">
                    <strong> Prescripteur</strong>
                  </Divider>
                  <Row gutter={16}>
                    <Col span={16}>
                      <Form.Item name="codespe" label="Spécialités">
                        <Select
                          style={{ width: "100%" }}
                          defaultValue="--Selectionner--"
                          onChange={handleFournisPrescChange}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {specialitesData &&
                            specialitesData.map((specialite) => (
                              <Option
                                key={specialite.codespe}
                                value={specialite.codespe}
                              >
                                {`${specialite.codespe} - ${specialite.intitule}`}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="datepresc" label="Date prescription">
                        <DatePicker disabled={!isPrescripteurSelectEnabled} disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        } format="DD/MM/YYYY" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item name="codepresc" label="Prescripteur">
                    <Select
                      defaultValue="--Selectionner--"
                      style={{ width: "100%" }}
                      disabled={!isPrescripteurSelectEnabled && !isEdit}
                      showSearch
                      allowClear={false}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {prescripteursData.map((prescripteur) => (
                        <Option
                          key={prescripteur.numFourn}
                          value={prescripteur.numFourn}
                        >
                          {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={12}>
                  <Divider orientation="left">
                    <strong> Bénéficiaire</strong>
                  </Divider>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        name="typebenef"
                        label="Types"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une option",
                          },
                        ]}
                      >
                        <Select
                          style={{ width: "100%", fontSize: "16px" }}
                          disabled={!isMatriculeSelected && !isEdit}
                          defaultValue="--Selectionner--"
                          onChange={handleTypeBenefChange}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {benefsData &&
                            benefsData.map((benefData) => (
                              <Option
                                key={benefData.codetype}
                                value={benefData.codetype}
                              >
                                {`${benefData.libtype} `}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item
                        name="matribenef"
                        label="Bénéficiaire"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une option",
                          },
                        ]}
                      >
                        <Select
                          defaultValue="--Selectionner--"
                          style={{ width: "100%" }}
                          disabled={!isBeneficiaireSelected && !isEdit}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {Array.isArray(beneficiaires) &&
                            beneficiaires.map((beneficiaire) => (
                              <Option
                                key={beneficiaire.matribenef}
                                value={beneficiaire.matribenef}
                              >
                                {`${beneficiaire.matribenef} - ${beneficiaire.prenoms ? beneficiaire.prenoms + " " : ""
                                  }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider orientation="left">
                    <strong> Structure de santé</strong>
                  </Divider>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item name="codeprest" label="Types">
                        <Select
                          style={{ width: "100%" }}
                          defaultValue="--Selectionner--"
                          onChange={handleFournisseurChange}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {specialitesData &&
                            specialitesData
                              .filter((specialite) =>
                                !["01", "04", "06"].includes(specialite.codespe)
                              )
                              .map((specialite) => (
                                <Option
                                  key={specialite.codespe}
                                  value={specialite.codespe}
                                >
                                  {` ${specialite.intitule}`}
                                </Option>
                              ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="categ" label="Catégorie">
                        <Select
                          defaultValue="--Selectionner--"
                          style={{ width: "100%" }}
                        >
                          <Option value="1">1ère Catégorie</Option>
                          <Option value="2">2ème Catégorie</Option>
                          <Option value="3">3ème Catégorie</Option>
                          <Option value="4">4ème Catégorie</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item name="codefourn" label="Prestataire"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner un prestataire",
                      },
                    ]}>
                    <Select
                      defaultValue="--Selectionner--"
                      style={{ width: "100%" }}
                      disabled={!isSaisirMedicamentClicked && !isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {prescripteurData.map((prescripteur) => (
                        <Option
                          key={prescripteur.numFourn}
                          value={prescripteur.numFourn}
                        >
                          {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="natprest"
                    label="Nature prestation"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select style={{ width: "100%" }}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }>
                      {prestationsData &&
                        prestationsData.map((prestation) => (
                          <Option
                            key={prestation.codeprest}
                            value={prestation.codeprest}
                          >
                            {`${prestation.codeprest} - ${prestation.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Divider orientation="left">
                    <strong>Motif d'hospitalisation</strong>
                  </Divider>
                  <Row gutter={16}>
                    <Form.Item
                      name="montant_remise"
                      label="Remise"
                      initialValue={0}
                      className={isSaisirMedicamentClicked ? "" : "hidden"}
                      style={{ marginRight: "16px" }}
                    >
                      <InputNumber />
                    </Form.Item>
                    <Form.Item
                      initialValue={0}
                      name="nbarticle"
                      label=" Nombre d'article"
                      className={isSaisirMedicamentClicked ? "" : "hidden"}
                    >
                      <InputNumber />
                    </Form.Item>
                    <Form.Item
                      initialValue={0}
                      label="Quantité Total"
                      className={isSaisirMedicamentClicked ? "" : "hidden"}
                    >
                      <InputNumber
                        value={qteTotal}
                      // defaultValue={0}

                      />
                    </Form.Item>
                  </Row>
                  <Form.Item
                    name="codeacte" >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="Saisir les actes"
                      disabled={!isSaisirMedicamentClicked && !isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {actesData &&
                        actesData.map((acte) => (
                          <Option key={acte.codeacte} value={acte.codeacte}>
                            {`${acte.libacte} `}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        name="qte"
                        label="Qté"
                        initialValue={1}
                        className={isEdit || isSaisirMedicamentClicked ? "" : "hidden"}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="tarif"
                        label="Tarif"
                        initialValue={0}
                        className={isEdit || isSaisirMedicamentClicked ? "" : "hidden"}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <PlusCircleOutlined
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          color: "#4DBD74",
                        }}
                        className={isEdit || isSaisirMedicamentClicked ? "" : "hidden"}
                        onClick={handleAddRow}
                      />
                      <CloseCircleFilled
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          paddingLeft: "8px",
                          color: "#ff2317",
                        }}
                        className={isEdit || isSaisirMedicamentClicked ? "" : "hidden"}
                        onClick={handleClearTable}
                      />
                    </Col>
                  </Row>


                  {isTableVisible && (
                    <Table
                      style={{
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                      className="custom-header1-table"
                      bordered
                      showSorterTooltip={false}
                      dataSource={[...displayRows]}
                      scroll={{ x: true }}
                      columns={[
                        {
                          title: "N°",
                          dataIndex: "numero",
                          key: "numero",
                          align: "center",
                        },
                        {
                          title: "Nom",
                          dataIndex: "libacte",
                          key: "libacte",
                        },
                        {
                          title: "Qt",
                          dataIndex: "qte",
                          key: "qte",
                          align: "center",
                        },
                        {
                          title: "Tarif",
                          dataIndex: "tarif",
                          key: "tarif",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },
                        {
                          title: (
                            <div
                              style={{
                                backgroundColor: "#010f1c",
                                color: "white",
                                padding: "1px",
                              }}
                            ></div>
                          ),
                          dataIndex: "actions",
                          key: "actions",
                          align: "center",
                          fixed: "right", // Fixe la colonne à droite
                          render: (text, record) => (
                            <span>
                              <Popconfirm
                                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                                onConfirm={() => handleDelete(record)}
                                okText="Oui"
                                cancelText="Non"
                              >
                                <Tooltip title="Supprimer">
                                  <DeleteFilled
                                    style={{ cursor: "pointer", color: "red" }}
                                  />
                                </Tooltip>
                              </Popconfirm>
                            </span>
                          ),
                        },
                      ]}
                    />

                  )}
                </Col>
              </Row>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Form.Item name="remb_integral" style={{ marginBottom: 0 }} valuePropName="checked">

                  <Checkbox>   Remboursement Intégral</Checkbox>

                </Form.Item>
                <Button
                  type="dashed"
                  danger
                  onClick={handleCloseModal}
                  style={{ marginRight: 8 }}
                >
                  Fermer
                </Button>
                {isEdit ? (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleModif}
                  >
                    Modifier
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleOk}
                  >
                    Valider
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Modal>
        <Modal
          open={isParticipantInactive}
          title="Participant inactif!"
          onCancel={() => {
            setIsParticipantInactive(false);
            setSelectedParticipant(null);
          }}
          footer={
            userProfil === 'role_1' || userProfil === 'role_2' ? (
              [
                <Button key="cancel" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Annuler
                </Button>,
                <Button key="confirm" type="primary" onClick={() => {
                  setIsMatriculeSelected(true);
                  const benefData = participantsIpmService.getBenefParticipant(selectedParticipant.numcont);
                  setAllBeneficiaires(benefData);
                  setBeneficiaires(benefData);
                  setPartsData(selectedParticipant);
                  setIsBeneficiaireSelected(false);
                  form.setFieldsValue({
                    codetype: undefined,
                    matribenef: undefined,
                  });
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                }}>
                  Valider
                </Button>
              ]
            ) : (
              [
                <Button key="ok" type="primary" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Ok
                </Button>
              ]
            )
          }
        >
          <p>Participant inactif! Veuillez confirmer cette opération.</p>
        </Modal>

      </Card>
    </div>
  );
};

export default LgHospi;
